export function cleanPhone(value: string) {
  const phone = value.trim().replace(/[^\w\s]/gi, '')

  if (phone.startsWith('55') && phone.length === 13) {
    return phone.slice(2)
  }

  return phone
}
